var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq23(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.827344,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0637,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.6511,
    y1: 12.1824,
    x2: 49.8875,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.977321,
    y1: 49.8543,
    x2: 12.2136,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.4133,
    y1: 38.6199,
    x2: 49.6496,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.739476,
    y1: 0.944118,
    x2: 11.9758,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.714 30.23C20.4313 28.942 21.7567 27.7893 22.69 26.772C23.6327 25.7453 24.104 24.742 24.104 23.762C24.104 23.118 23.9407 22.6047 23.614 22.222C23.2967 21.83 22.774 21.634 22.046 21.634C21.3367 21.634 20.786 21.858 20.394 22.306C20.0113 22.7447 19.7967 23.3327 19.75 24.07H18.798C18.854 23.034 19.1713 22.2313 19.75 21.662C20.338 21.0833 21.1033 20.794 22.046 20.794C22.9513 20.794 23.684 21.0507 24.244 21.564C24.804 22.068 25.084 22.7867 25.084 23.72C25.084 24.8493 24.6127 25.946 23.67 27.01C22.7367 28.0647 21.584 29.096 20.212 30.104H25.392V30.93H18.714V30.23ZM26.8797 23.524C26.9451 22.6747 27.2717 22.0073 27.8597 21.522C28.4571 21.0273 29.2271 20.78 30.1697 20.78C30.7951 20.78 31.3317 20.892 31.7797 21.116C32.2277 21.34 32.5637 21.648 32.7877 22.04C33.0211 22.4227 33.1377 22.8567 33.1377 23.342C33.1377 23.93 32.9651 24.4387 32.6197 24.868C32.2744 25.2973 31.7844 25.5633 31.1497 25.666V25.736C31.8124 25.8667 32.3397 26.156 32.7317 26.604C33.1237 27.0427 33.3197 27.6213 33.3197 28.34C33.3197 29.1427 33.0491 29.8007 32.5077 30.314C31.9757 30.818 31.2011 31.07 30.1837 31.07C29.2131 31.07 28.4151 30.818 27.7897 30.314C27.1644 29.8007 26.8051 29.0773 26.7117 28.144H27.6637C27.7477 28.7693 28.0091 29.278 28.4477 29.67C28.8864 30.0527 29.4651 30.244 30.1837 30.244C30.8931 30.244 31.4344 30.0573 31.8077 29.684C32.1904 29.3107 32.3817 28.8347 32.3817 28.256C32.3817 26.8373 31.3597 26.128 29.3157 26.128H29.0077V25.302H29.3297C31.2337 25.302 32.1857 24.6813 32.1857 23.44C32.1857 22.8987 32.0084 22.4647 31.6537 22.138C31.2991 21.802 30.7951 21.634 30.1417 21.634C29.5071 21.634 28.9797 21.802 28.5597 22.138C28.1491 22.4647 27.9064 22.9267 27.8317 23.524H26.8797Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq23);
export default __webpack_public_path__ + "static/media/fq23.76ee1121aa8973417eb642d3616949a5.svg";
export { ForwardRef as ReactComponent };